import js_cookie from "js-cookie";
const createCookiesAPI = (options)=>js_cookie.withAttributes({
        domain: '.purina.com',
        ...options
    }).withConverter({
        write: js_cookie.converter.write,
        read: function(value, name) {
            value = value.replace(/\+/g, ' ');
            return js_cookie.converter.read(value, name);
        }
    });
export { createCookiesAPI };
